import { Esqueleto } from '@/components/ui/skeleton';

/** Forma aproximada de um bloco enquanto ele carrega. */
export function EsqueletoBloco() {
  return (
    <div className="flex flex-col gap-5">
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
        {Array.from({ length: 4 }, (_, indice) => (
          <Esqueleto key={indice} className="h-20" />
        ))}
      </div>
      <Esqueleto className="h-64" />
      <div className="grid gap-5 lg:grid-cols-2">
        <Esqueleto className="h-56" />
        <Esqueleto className="h-56" />
      </div>
      <p className="apenas-leitor-tela" role="status">
        Carregando relatório…
      </p>
    </div>
  );
}
